module.exports = "<p>\n  approvance-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/approvance/approvance-form/approvance-form.component.html
// module id = ./src/app/finance/approvance/approvance-form/approvance-form.component.html
// module chunks = main